import apis from "./apis";
import api from "./api";
import api2 from "./api2";
import app from "./app";
import chain, { l1Chain } from "./chain";
import * as features from "./features";
import meta from "./meta";
import services from "./services";
import UI from "./ui";

const config = Object.freeze({
  app,
  chain,
  l1Chain,
  apis,
  api2,
  api,
  UI,
  features,
  services,
  meta,
});

export default config;
